import React, {useState, useEffect, useMemo} from "react";
import DropDownLevel from "./DropDownLevel";
import DropDownSupremeChapter from "./DropDownSupremeChapter";
import DropDownChapter from "./DropDownChapter";
import {updateClassLevelChapter} from "../../../../network/Endpoint";
import DropDownStageType from "./DropDownStageType";
import {useRecoilState} from "recoil";
import {classLearningMenuState} from "../../../../recoil/menuState/classLearningMenuState";
import {lessonStageMenu} from "../../../../recoil/lesson/lessonState";
// import {updateClassLevelChapter} from "../../../../network/Endpoint";

const CurriculumDropdownInApp = ({ classId, level, setLevel, supremeChapter, setSupremeChapter, chapter, setChapter, curriculumData, selectedChapter, setSelectedChapter, menuType}) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [stageMenu, setStageMenu] = useRecoilState(lessonStageMenu);
    const [classLearningMenu, setClassLearningMenu] = useRecoilState(classLearningMenuState);

    const types = useMemo(() => [
        { type: "lesson", typeName: "학교 학습(수업)", page: "/page/classLesson"},
        { type: "homework", typeName: "학교 학습(숙제)", page: "/page/classHomework"},
        { type: "daily", typeName: "오늘의 학습", page: "/page/classDaily"},
    ], []);

    // 📌 챕터 변경 시, 첫 번째 레슨 선택 (처음 로딩 시 실행 안 함)
    useEffect(() => {
        if (selectedChapter) {
            setLevel(curriculumData[selectedChapter.level-1]);
            setSupremeChapter(curriculumData[selectedChapter.level-1].supremeChapterList[selectedChapter.supremeChapterSeq]);
            setChapter(curriculumData[selectedChapter.level-1].supremeChapterList[selectedChapter.supremeChapterSeq].chapterList[selectedChapter.chapterSeq]);
            setClassData(curriculumData[selectedChapter.level-1], selectedChapter.supremeChapterSeq, selectedChapter.chapterSeq);
            setSelectedChapter(null);
        }
    }, [selectedChapter]);

    useEffect(() => {
        if(stageMenu){
            setClassLearningMenu(stageMenu.type);
        }else{
            setStageMenu(types[2]);
        }
    }, [setClassLearningMenu, stageMenu]);


    // 선택한 단원 저장
    const setClassData = async (level, supremeChapterSequence, chapterSequence) => {
        try{
            const body = { type: menuType, classId: classId, level: level.level, supremeChapterSequence: supremeChapterSequence, chapterSequence: chapterSequence };
            const res = await updateClassLevelChapter(body);
        }catch (error) {
            alert(`[${error.message}]\n 단원정보 저장중 오류가 발생했어요.`);
        }
    }

    return (
        <div className="flex flex-row w-[1027px] justify-start items-center gap-3">
            <DropDownStageType
                stageMenu={stageMenu}
                setStageMenu={setStageMenu}
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                types={types}
            />
            <DropDownLevel
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                curriculumData={curriculumData}
                level={level}
                setSelectedChapter={setSelectedChapter}
            />
            <DropDownSupremeChapter
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                level={level}
                supremeChapter={supremeChapter}
                setSelectedChapter={setSelectedChapter}
            />
            <DropDownChapter
                openDropdown={openDropdown}
                setOpenDropdown={setOpenDropdown}
                level={level}
                supremeChapter={supremeChapter}
                chapter={chapter}
                setChapter={setChapter}
                selectedChapter={selectedChapter}
                setSelectedChapter={setSelectedChapter}
            />
        </div>
    );
};

export default CurriculumDropdownInApp;
